var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-10 h-10 flex items-center justify-center rounded-full bg-blue-100 text-blue-800"},[_vm._v(" "+_vm._s(_vm.initials)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }